// @ts-expect-error
import {ENGAGEMENT_FOUNDATION_MONTHLY, MARKETING_FOUNDATION_MONTHLY} from 'shells/billing/consts';

import type {
    GetAvailablePlans_recurlyAvailablePlans_crm as Crm,
    GetAvailablePlans_recurlyAvailablePlans_inbox as Engagement,
    GetAvailablePlans_recurlyAvailablePlans_marketingSuite as MarketingSuite,
    PlanSelectionUpdateInput,
    AddOnSelection,
} from 'nutshell-graphql-types';

import type {AddOns} from '../../../setup/billing/graphql/hooks/use-get-available-plans';

export function buildActivateQuotesInput(
    crm: Crm,
    engagement: Engagement | null | undefined,
    marketingSuite: MarketingSuite | null | undefined,
    addOns: AddOns,
    quotesDefaultCode: string
): PlanSelectionUpdateInput {
    const activeCrmPlan = crm.plans.find((plan) => plan.isActive);
    const crmPlanCode = activeCrmPlan?.code ?? crm.defaultCode;
    const numberOfUsers = activeCrmPlan?.quantity ?? crm.enabledUsers;

    const activeEngagementPlan = engagement?.plans.find((plan) => plan.isActive);
    const engagementPlanCode =
        activeEngagementPlan && activeEngagementPlan.code !== ENGAGEMENT_FOUNDATION_MONTHLY
            ? activeEngagementPlan.code
            : null;
    const numberOfEngagementUsers =
        activeEngagementPlan && !activeEngagementPlan.isFake ? activeEngagementPlan.quantity : 0;

    const activeMarketingSuitePlan = marketingSuite?.plans.find((plan) => plan.isActive);
    const marketingSuitePlanCode =
        activeMarketingSuitePlan &&
        activeMarketingSuitePlan.code !== MARKETING_FOUNDATION_MONTHLY &&
        !activeMarketingSuitePlan.isFake
            ? activeMarketingSuitePlan.code
            : null;

    const activeAddOns: AddOnSelection[] = [];

    const addOnEntries = [
        addOns.marketing,
        addOns.revenueBooster,
        addOns.nutshellIq,
        addOns.smsCampaigns,
        addOns.nutshellAdvisor,
    ] as const;

    for (const group of addOnEntries) {
        const activePlan = group.plans.find((plan) => plan.isActive);
        if (activePlan && !activePlan.isFake) {
            activeAddOns.push({
                product: activePlan.product,
                planCode: activePlan.code,
                quantity: group.isUserQuantityBased ? activePlan.quantity : null,
            });
        }
    }

    activeAddOns.push({product: 'QUOTES', planCode: quotesDefaultCode});

    return {
        crmPlanCode,
        numberOfUsers,
        engagementPlanCode,
        numberOfEngagementUsers,
        marketingSuitePlanCode,
        addOns: activeAddOns,
    };
}
